<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { colors, lineTrendOption } from "./chart-options";

export default {
  name: "KeywordTrendChart",
  components: { ChartCanvas },
  props: { trend: { type: Array, default: () => [] } },
  computed: {
    empty() {
      return !this.trend.some(
        (item) =>
          item.top10 !== null || item.top20 !== null || item.top30 !== null
      );
    },
    option() {
      return lineTrendOption(this.trend, [
        { name: "首页量", key: "top10", color: colors.blue },
        { name: "前二页", key: "top20", color: colors.orange },
        { name: "前三页", key: "top30", color: colors.green },
      ]);
    },
  },
};
</script>
